<template>
  <div class="mf-card chart-container">
    <div v-if="!isPdf" class="container-header">
      <span class="pa-1 table-card-title"> Bairros </span>
      <div class="header-actions">
        <todos :disabled="Boolean(infoBairro.length)" :tipo-pessoa="tipoPessoa" :clientes-nao-resolvidos="notResolvedClients" />
        <export-data :data-fetcher="getDataToExport" filename="perfil_demografico_bairros" ghost />
      </div>
    </div>
    <mf-loading :loader="['last-update', 'primeiro-registro', 'bairro-fisica', 'bairro-juridica', 'geo-status']" :width="4" :height="70" loader-type="table">
      <v-container v-if="infoBairro.length" fluid class="pa-0" fill-height>
        <v-layout align-start wrap>
          <v-flex xs12 md6>
            <data-card :info-bairro="infoBairro" :tipo-pessoa="tipoPessoa" :isPdf="isPdf" />
            <p
              v-if="!$wait.is(['last-update', 'primeiro-registro', 'bairro-fisica', 'bairro-juridica', 'geo-status']) && infoBairro.length && !isPdf"
              class="px-4 ma-0 caption secondary-text"
            >
              {{ notResolvedClients | localeString(0) }} clientes não resolvidos
            </p>
          </v-flex>
          <v-flex xs12 md6>
            <chart :array="infoBairro" label-property-name="DES_BAIRRO" data-property-name="NUM_CLIENTES_CADASTRADOS" />
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else class="my-6">
        <v-row align="center">
          <v-col align="center">
            <span class="subtitle">Nenhum resultado encontrado</span>
          </v-col>
        </v-row>
      </v-container>
    </mf-loading>
  </div>
</template>

<script>
import { orderBy } from 'lodash'
import DataCard from '@/modules/clientes/perfil-demografico/views/pages/BairroDataTable.vue'
import Chart from '@/modules/clientes/perfil-demografico/views/pages/PerfilDemograficoChart.vue'
import Todos from '@/modules/clientes/perfil-demografico/views/pages/BairrosTodos.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DataCard,
    Chart,
    Todos,
    ExportData: () => import('@/components/export-data/ExportData.vue'),
  },
  props: {
    tipoPessoa: String,
    isPdf: {
      type: Boolean,
      default: false,
    },
    notResolvedClients: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      stateInfoBairroFisica: (state) => state.clientes.perfilDemograficoBairroFisica,
      stateInfoBairroJuridica: (state) => state.clientes.perfilDemograficoBairroJuridica,
      stateFilters: (state) => state.filters,
    }),
    infoBairro() {
      const infoBairroArray = orderBy(this.tipoPessoa === 'F' ? this.stateInfoBairroFisica : this.stateInfoBairroJuridica, 'NUM_CLIENTES_CADASTRADOS', 'desc')
      if (infoBairroArray.length > 9) {
        const othersTotal = infoBairroArray.splice(9).reduce((total, object) => {
          return total + object['NUM_CLIENTES_CADASTRADOS']
        }, 0)
        infoBairroArray.push({
          DES_BAIRRO: 'Outros',
          NUM_CLIENTES_CADASTRADOS: othersTotal,
        })
      }
      const totalCadastros = infoBairroArray.reduce((total, current) => total + current['NUM_CLIENTES_CADASTRADOS'], 0)

      return infoBairroArray.map((object) => {
        if (object['DES_BAIRRO'] === '') {
          object['DES_BAIRRO'] = 'NÃO INFORMADO'
        }
        object['PORCENTAGEM'] = (object['NUM_CLIENTES_CADASTRADOS'] / totalCadastros) * 100
        return object
      })
    },
  },
  methods: {
    getDataToExport() {
      const infoBairroArray = this.tipoPessoa === 'F' ? this.stateInfoBairroFisica : this.stateInfoBairroJuridica
      const exportData = {
        headers: ['Bairro', 'Cidade', 'Estado', 'Pais', 'Clientes'],
        rows: infoBairroArray.map((data) => [data.DES_BAIRRO, data.DES_CIDADE_SN, data.DES_ESTADO_SN, data.DES_PAIS, data.NUM_CLIENTES_CADASTRADOS]),
      }
      return exportData
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin: 16px 0;
  .container-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
